export const getReversibleQuantity = (lineItem: { quantity: number; reversedQuantity?: number }) =>
	Math.max(lineItem.quantity - (lineItem.reversedQuantity ?? 0), 0);
